/* ============================================================================
   Enganche con la tienda real: variantes de Shopify y formulario de Releasit.
   Se carga DESPUÉS de cam.js.
   ========================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ------------------------------------------- el pack elegido es la variante */
  const campo = $('[data-cam-variante]');
  const forma = $('#cam-form') || (campo && campo.closest('form'));

  document.addEventListener('cam:pack', () => {
    const activo = $('.cam-pack.es-activo');
    if (!activo || !campo) return;
    const id = activo.dataset.variante;
    if (!id || campo.value === id) return;
    campo.value = id;
    campo.dispatchEvent(new Event('change', { bubbles: true }));
    if (forma) forma.dispatchEvent(new Event('change', { bubbles: true }));
    try {
      const u = new URL(location.href);
      u.searchParams.set('variant', id);
      history.replaceState({}, '', u);
    } catch (e) {}
  });

  /* --------------------------------------------------- el botón de Releasit */
  /* Releasit mete su propio botón dentro del <form>. Mientras no haya cargado,
     el nuestro queda de respaldo; cuando aparece, el CSS esconde el nuestro y
     este puente hace que tocar el nuestro abra el suyo. */
  const suyo = () => $$('[id^="rsi_buy_now_button"]').find(b => b.offsetWidth > 0) || null;

  $$('[data-cam-comprar]').forEach(b => b.addEventListener('click', e => {
    const r = suyo();
    if (r) { e.preventDefault(); r.click(); }
  }));

  /* ------------------------------- se cerró el formulario sin hacer el pedido */
  /* El formulario de Releasit va en position:fixed y se BORRA del DOM al
     cerrarse, así que no sirve mirar offsetParent ni esperar a que se oculte:
     se comprueba cada tanto si sigue estando, y cuando deja de estar se abre la
     ventana de descuento. */
  const abierto = () => $$('#rsi_form_wrapper, [id^="rsi_form"], [class*="rsi-form-wrapper"], [class*="rsi-form-main"]')
    .some(e => e.isConnected && e.offsetHeight > 200);

  /* Releasit trae SU PROPIA ventana de descuento al abandonar el formulario
     (la del código VUELVE10). Si está activada en su panel, sale la suya y la
     nuestra se queda callada: dos ventanas de descuento seguidas, con dos
     códigos distintos, es peor que ninguna. Para usar la nuestra hay que apagar
     la de Releasit en su panel. */
  const suPopup = /felicidades|descuento|cup[oó]n|discount|promo/i;
  const popupDeReleasit = () => $$('[id^="rsi"], [class*="rsi"]').some(e =>
    e.isConnected && e.offsetHeight > 100 && suPopup.test(e.textContent || ''));

  let estaba = false, saliendo = false, huboPopupAjeno = false;
  window.addEventListener('beforeunload', () => { saliendo = true; });
  window.addEventListener('pagehide', () => { saliendo = true; });

  setInterval(function () {
    if (popupDeReleasit()) huboPopupAjeno = true;
    const ahora = abierto();
    if (ahora && !estaba) { estaba = true; return; }
    if (!ahora && estaba) {
      estaba = false;
      if (huboPopupAjeno) return;
      // Si el pedido se creó, Releasit navega a la página de gracias y para
      // entonces ya estamos saliendo. Si seguimos aquí, es que lo cerraron.
      setTimeout(function () {
        if (!saliendo && !document.hidden && window.camAbrirDescuento) window.camAbrirDescuento();
      }, 320);
    }
  }, 350);

  /* -------------------------------- llevar el cupón al formulario de pedido */
  document.addEventListener('cam:usar-descuento', e => {
    const codigo = e.detail;
    const poner = () => {
      const campos = $$('input').filter(i => {
        const t = ((i.name || '') + ' ' + (i.id || '') + ' ' + (i.placeholder || '')).toLowerCase();
        return t.includes('discount') || t.includes('descuento') || t.includes('cupon') || t.includes('cupón') || t.includes('coupon');
      });
      if (!campos.length) return false;
      campos.forEach(i => {
        i.value = codigo;
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return true;
    };
    // El formulario tarda en montarse: se intenta unas cuantas veces y se deja.
    let intentos = 0;
    const reloj = setInterval(() => {
      if (poner() || ++intentos > 14) clearInterval(reloj);
    }, 420);
  });
})();
